export default __webpack_public_path__ + "static/media/vg_logo_small.31328b81.svg";